// Backwards-compatible wrapper: when a slotKey is supplied and the photo has
// been uploaded via the dashboard, we render the real image; otherwise the
// classic gray placeholder is shown so layout never breaks.
import { SitePhoto } from "@/components/SitePhoto";

interface PlaceholderImageProps {
  label: string;
  className?: string;
  slotKey?: string;
  sizes?: string;
}

export function PlaceholderImage({ label, className, slotKey, sizes }: PlaceholderImageProps) {
  return <SitePhoto label={label} slotKey={slotKey} className={className} sizes={sizes} />;
}
